// ----------------------------
// Virtual Market
// ----------------------------

// ------------------------------------
// Imports
// ------------------------------------
import { put, call, takeLatest } from 'redux-saga/effects'
import {
  GET_QUESTIONS, getQuestionsSucceeded, getQuestionsFailed,
  USER_IS_SUITABLE, userIsSuitableSucceeded, userIsSuitableFailed,
  SEND_CONTRACT, sendContractSucceeded, sendContractFailed,
    GET_QUESTIONS_ID, getQuestionsIdSucceeded, getQuestionsIdFailed,
    GET_PAIS, getPaisSucceeded, getPaisFailed, asignarEstadoCuestionarios
} from '../modules/module_questions.js'
import { API_REQUEST_STATUS_SUCCEEDED, API_REQUEST_STATUS_FAILED } from 'services/config'
import { doCallback } from 'utilities/general-utils'
import { guardarEstadoCuestionarios } from 'utilities/session-utils'
// ------------------------------------
// Services
// ------------------------------------
import { fetchQuestions, userIsSuitable, sendContract, fetchQuestionsXID, getPaises } from 'services/question-api'

// ------------------------------------
// Sagas
// ------------------------------------

/* Sagas - Workers */
function* getQuestionsRequested(action) {
  const { response, error } = yield call(fetchQuestions, action.token);

  let actionToDo = null;
  let message = API_REQUEST_STATUS_FAILED;

  if(response) {
    message = API_REQUEST_STATUS_SUCCEEDED;
    if (response.data.length !== 0){
      let incluision = prepareInclusion(response.data[0]);
      actionToDo = getQuestionsSucceeded(incluision, response.data[1], response.data[2], response.data[3], response.data[4], response.data[5]);
      const estadoCuestionarios = {
        inclusion: response.data[0].activo,
        socioBasico: response.data[1].activo,
        salida: response.data[2].activo,
        socioCampana: response.data[3].activo,
        menosSaludable: response.data[4].activo,
        salidaCampaign: response.data[5].activo
      }
      yield put(asignarEstadoCuestionarios(estadoCuestionarios));
      guardarEstadoCuestionarios(estadoCuestionarios);
    } else {
      actionToDo = getQuestionsSucceeded([], [], [], [], [], []);
      const estadoCuestionarios = {
        inclusion: false,
        socioBasico: false,
        salida: false,
        socioCampana: false,
        menosSaludable: false,
        salidaCampaign: false,
      }
      yield put(asignarEstadoCuestionarios(estadoCuestionarios));
      guardarEstadoCuestionarios(estadoCuestionarios);
    }
  } else {
    actionToDo = getQuestionsFailed(error);
  }

  yield put(actionToDo);

  if (action.callback){
    doCallback(action.callback, message, response ? response.data : null);
  }
}

function* getQuestionsIdRequested(action) {
  const { response, error } = yield call(fetchQuestionsXID, action.token, action.term);

  let actionToDo = null;
  let message = API_REQUEST_STATUS_FAILED;

  if(response) {
    message = API_REQUEST_STATUS_SUCCEEDED;
    actionToDo = getQuestionsIdSucceeded(response.data);
  } else {
    actionToDo = getQuestionsIdFailed(error);
  }

  yield put(actionToDo);

  if (action.callback){
    doCallback(action.callback, message, response ? response.data : null);
  }
}

function* userIsSuitableRequested(action) {
  const { response, error } = yield call(userIsSuitable, action.token, action.term);

  let actionToDo = null;
  let message = API_REQUEST_STATUS_FAILED;

  if(response) {
    message = API_REQUEST_STATUS_SUCCEEDED;
    actionToDo = userIsSuitableSucceeded();
  } else {
    actionToDo = userIsSuitableFailed(error);
  }

  yield put(actionToDo);

  if (action.callback){
    doCallback(action.callback, message, response ? response.data : null);
  }
}

function* sendContractRequested(action) {
  const { response, error } = yield call(sendContract, action.token, action.term);

  let actionToDo = null;
  let message = API_REQUEST_STATUS_FAILED;

  if(response) {
    message = API_REQUEST_STATUS_SUCCEEDED;
    actionToDo = sendContractSucceeded();
  } else {
    actionToDo = sendContractFailed(error);
  }

  yield put(actionToDo);

  if (action.callback){
    doCallback(action.callback, message, response ? response.data : null);
  }
}

function* getPaistRequested(action) {
    const { response, error } = yield call(getPaises);

    let actionToDo = null;
    let message = API_REQUEST_STATUS_FAILED;

    if(response) {
        message = API_REQUEST_STATUS_SUCCEEDED;
        actionToDo = getPaisSucceeded(response.data);
    } else {
        actionToDo = getPaisFailed(error);
    }

    yield put(actionToDo);

    if (action.callback){
        doCallback(action.callback, message, response ? response.data : null);
    }
}

/* Sagas - Watchers/Listeners */
export function* watchGetQuestions() {
  yield takeLatest(GET_QUESTIONS, getQuestionsRequested);
}

export function* watchGetQuestionsId() {
  yield takeLatest(GET_QUESTIONS_ID, getQuestionsIdRequested);
}

export function* WatchUserIsSuitable() {
  yield takeLatest(USER_IS_SUITABLE, userIsSuitableRequested)
}

export function* watchSendContract() {
  yield takeLatest(SEND_CONTRACT, sendContractRequested)
}

export function* watchGetPais() {
    yield takeLatest(GET_PAIS, getPaistRequested)
}

// ------------------------------------
// Exports Functions
// ------------------------------------

export const questionSagas = [
    watchGetQuestions,
    watchGetQuestionsId,
    WatchUserIsSuitable,
    watchGetPais,
    watchSendContract
];



function prepareInclusion(questionnaire){
  return {
    ...questionnaire,
    texto: `pkCuestionario${questionnaire.pkCuestionario}`,
    preguntas: questionnaire.preguntas.map(pregunta => ({
      ...pregunta,
      texto: `pkPregunta${pregunta.pkPregunta}`,
      opciones: pregunta.opciones.map(opcion => ({
        ...opcion,
        texto: `pkOpcion${opcion.pkOpcion}`,
      }))
    }))
  }
}


// WEBPACK FOOTER //
// ./src/store/sagas/sagas_question.js